export function debounce( fn, delay ) {
	let timer;
	return ( ...args ) => {
		clearTimeout( timer );
		timer = setTimeout( () => fn( ...args ), delay );
	};
}

export function syncFiltersToURL( filters ) {
	const url    = new URL( window.location.href );
	const params = url.searchParams;

	const map = {
		search:     'mwsb_s',
		categories: 'mwsb_cat',
		tags:       'mwsb_tag',
		minPrice:   'mwsb_min_price',
		maxPrice:   'mwsb_max_price',
		orderby:    'mwsb_orderby',
	};

	Object.entries( map ).forEach( ( [ key, param ] ) => {
		const val = filters[ key ];
		if ( Array.isArray( val ) ) {
			params.delete( param );
			val.forEach( ( v ) => params.append( param, v ) );
		} else if ( val && val !== 'menu_order' && val !== 1 ) {
			params.set( param, val );
		} else {
			params.delete( param );
		}
	} );

	window.history.replaceState( {}, '', url.toString() );
}

export function getFiltersFromURL() {
	const params = new URLSearchParams( window.location.search );

	return {
		search:     params.get( 'mwsb_s' ) || '',
		categories: params.getAll( 'mwsb_cat' ),
		tags:       params.getAll( 'mwsb_tag' ),
		minPrice:   params.get( 'mwsb_min_price' ) || '',
		maxPrice:   params.get( 'mwsb_max_price' ) || '',
		orderby:    params.get( 'mwsb_orderby' ) || 'menu_order',
		page:       1,
	};
}

export function classNames( ...classes ) {
	return classes.filter( Boolean ).join( ' ' );
}

export function formatPrice( amount ) {
	const symbol = window.mwsbData?.currency || '$';
	return `${ symbol }${ parseFloat( amount ).toFixed( 2 ) }`;
}

export function getColumnClass( columns ) {
	return `mwsb-cols-${ columns }`;
}

export function range( start, end ) {
	return Array.from( { length: end - start + 1 }, ( _, i ) => start + i );
}
